<template>
  <section class="page-banner bg-light py-6">
    <div class="container text-center">

      <h1 class="fw-bold mb-2">
        {{ title }}
      </h1>

      <p v-if="subtitle" class="text-muted mb-0">
        {{ subtitle }}
      </p>

    </div>
  </section>
</template>

<script>
  export default {
    name: "PageBanner",
    props: {
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: "",
      },
    },
  };
</script>

<style scoped>
.page-banner {
  border-bottom: 1px solid #eee;
}
</style>
